// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1Iy_-","signatureButtonsRight":"ModalSign_signatureButtonsRight__1X3zT"};